import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';



import { MateriaisService } from '../../../../../providers/materiais-service';
import { AlertService } from './../../../../../providers/alert-service';
import { MenuService } from './../../../../../providers/menu-service';
import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from './../../../../../providers/usuario-service';
import { GestaoPcaService } from './../../../../../providers/gestao-pca-service';

@Component({
    selector: 'page-saldos-contabeis',
    templateUrl: 'saldos-contabeis.html',
    providers: [
        MateriaisService
    ]
})
export class SaldosContabeisPage extends ModulosController {
    listaDados: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;

    idSecaoPagina: string = "404";

    order: string = 'codigo';
    reverse: boolean = true;
    page: number = 1;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public materiaisService: MateriaisService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        this.setModuloId(13);

        this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
    }

    carregarDados() {
        this.materiaisService.obterSaldosContabeis().subscribe(data => {
            this.listaDados = data;
            console.log(this.listaDados);
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    formatarPorcentagem(valor) {
        return valor.toString().replace('.', ',') + "%";
    }

    voltarParaMateriais() {
        this.menuService.redirecionarPagina(this.materiaisService.obterIdPaginaMateriais());
    }

    salvarFlagIncluir() {
        this.loading = true;
        this.listaDados.dsResultadoAnalise = this.capitalize(this.listaDados.dsResultadoAnalise);
        this.materiaisService.salvarSaldosContabeis(this.listaDados).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.loading = false;
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
            this.loading = false;
        })
    }

    submeterNoCertificado() {

        let idAnalise = "";
        this.loading = true;
        if (this.listaDados.dsResultadoAnalise == undefined || !this.listaDados.dsResultadoAnalise || this.listaDados.dsResultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.dsResultadoAnalise == null) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                idAnalise = this.listaDados.idModuloAnalise;
                this.listaDados.dsResultadoAnalise = this.capitalize(this.listaDados.dsResultadoAnalise);
                this.materiaisService.submeterSaldosContabeis(this.listaDados).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaMateriais();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    capitalize(str) {
        let retorno = "";
    
        if (str) {
          retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }
    
        return retorno;
      }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/materiais/analista/saldos-contabeis/saldos-contabeis.ts